/**
 * Builds a URL with query parameters
 *
 * @param baseUrl The base URL without query parameters
 * @param params An object containing the query parameters
 * @returns A URL with properly formatted query parameters
 *
 * @example
 * // Returns "https://api.example.com/endpoint?param1=value1&param2=value2"
 * buildUrlWithParams("https://api.example.com/endpoint", { param1: "value1", param2: "value2" });
 *
 * // Handles undefined, null, and string 'null' values by skipping them
 */
export const buildUrlWithParams = (baseUrl: string, params: Record<string, unknown>): string => {
  // Filter out undefined, null, and string 'null' values
  const validParams = Object.entries(params).filter(([_, value]) => value && value !== 'null');

  if (validParams.length === 0) return baseUrl;

  // Build query string with proper separator
  const queryString = validParams
    .map(([key, value], index) => {
      const prefix = index === 0 ? '?' : '&';
      return `${prefix}${key}=${encodeURIComponent(String(value))}`;
    })
    .join('');

  return `${baseUrl}${queryString}`;
};

export default buildUrlWithParams;
